export type AchievementItem = { number: number, label?: string, icon: string, percentage?: number, tooltip?: string }

export enum AchievementType {
  CardsUpgrade = 'cardsUpgrade',
  CardsAbove15 = 'cardsAbove15',
  CardsAbove25 = 'cardsAbove25',
  CardsAbove50 = 'cardsAbove50',
  CardsAbove100 = 'cardsAbove100',
  CardsAbove150 = 'cardsAbove150',
  SpecialCards = 'specialCards',
  Friends = 'friends',
  DailyCheckinStreaks = 'dailyCheckinStreaks',
  Tasks = 'tasks',
  Spins = 'spins',
  Badges = 'badges',
  DaysSinceOnboarding = 'daysSinceOnboarding',
  OnChainTransactions = 'tonTxCount',
  Pathways = 'pathwayCompletionsCount',
  PathwaySteps = 'pathwayStepCompletionsCount',
  MysteryBoxes = 'revealedMysteryBoxes',
  DailyCombo = 'dailyCombo',
}

export type Achievement = Record<AchievementType, number>